<script setup>
import LeadStatus from "../../../common/LeadStatus.vue";
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
import {computed} from "vue";
import EditableTextField from "../../portal-editable-fields/EditableTextField.vue";

    const props = defineProps({
        leads: {
            type: Array,
            required: true
        },
    });

    const portalContentAndDesignStore = usePortalContentAndDesignStore();

    const layoutStyle = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout_layout_style);


</script>
<template>
    <table
        class="table"
        :class="{ 'table-wide': layoutStyle === 'none'}"
    >
        <thead>
        <tr>
            <th>
                <editable-text-field
                    text-type="span"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_leads_table_leads"
                ></editable-text-field>
            </th>
            <th>
                <editable-text-field
                    text-type="span"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_leads_table_status"
                ></editable-text-field>
            </th>
            <th>
                <editable-text-field
                    text-type="span"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_leads_table_converted_to"
                ></editable-text-field>
            </th>
            <th>
                <editable-text-field
                    text-type="span"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_leads_table_date"
                ></editable-text-field>
            </th>
        </tr>
        <tr class="h-1"/>
        </thead>
        <tbody>
        <tr
            v-for="(lead, index) in leads"
            class="hover:bg-gray-100 hover:bg-opacity-50"
            :key="`lead-${index}`"
        >
            <td class="whitespace-nowrap">
                <div class="font-medium group-hover:underline"
                     :class="`group-hover:${portalContentAndDesignStore.getLinkColorClass}`">
                    <span class="">{{ lead.lead_info.name }}</span>
                </div>
                <div class="font-medium group-hover:underline"
                     :class="`group-hover:${portalContentAndDesignStore.getLinkColorClass}`">
                    <span class="opacity-60">{{ lead.lead_info.email }}</span>
                </div>
            </td>
            <td class="font-medium whitespace-nowrap">
                <lead-status :status="lead.status_raw"/>
            </td>
            <td class="font-medium whitespace-nowrap">
                <div v-if="lead.converted_to">
                    <router-link
                        :to="{ name: 'referral-detail', params: { id: lead.converted_to.id } }"
                    >
                        {{ lead.converted_to.name }}
                    </router-link>
                </div>
                <div v-else class="font-medium group-hover:underline">
                    <span>-</span>
                </div>
            </td>

            <td class="whitespace-nowrap">
                <time
                    class="opacity-60"
                    :datetime="lead.created_at"
                >
                    {{ lead.created_at }}
                </time>
            </td>
        </tr>
        </tbody>
    </table>
</template>
